import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ItemsRolesTableFooter = styled.td`
    color: #152935;
    font-weight: bold;
    text-align: right;
    padding-right: 24px;
    padding-top: 8px;
    padding-bottom: "8px";
`;

export const ItemDescription = styled.span`
    text-overflow: ellipsis;
    display: block;
    max-width: 400px;
    overflow: hidden;
    white-space: nowrap;
`;

export const InfoIcon = styled(FontAwesomeIcon)`
    margin-left: 8px;
`;
